const config = {
    // UAT
        //apiURL: "https://uat-online-api.tradebulls.in/",
        //location:"https://uat-callback.tradebulls.in/location",
        //loginURL: "https://uat-login.tradebulls.in?referer=",
        //digilocker: "https://uat-callbacktbs.tradebulls.in/authorize/digilocker",
        //paymentGateway: "https://uat-callback.tradebulls.in/payRequest",

    // Live
        //  apiURL: "https://online-api.tradebulls.in/",
        //  location:"https://callback.tradebulls.in/location",
        //  loginURL: "https://login.tradebulls.in?referer=",
        //  digilocker: "https://callbacktbs.tradebulls.in/authorize/digilocker",
        //  paymentGateway: "https://callback.tradebulls.in/payRequest",


    // APIs
        verifySignup:"ms-trading-authservice/signup",
        refreshToken: "ms-trading-authservice/login",
        panVerification: "ms-diy-process/diy/staging/add/panDetails",
        getPanDetails: "ms-diy-process/diy/staging/get/panDetails",
        getKRA: "ms-diy-process/diy/report/getKra",
        getPersonalDetails: "ms-diy-process/diy/staging/get/personalDetails",
        personalDetails: "ms-diy-process/diy/staging/add/personalDetails",
        contactVerification : "ms-diy-process/diy/process/contactVerification",
        search: "ms-diy-process/diy/search",
        IFSCFinder : "ms-diy-process/diy/commonmasters/bank/bankfinder",
        getBankDetails : "ms-diy-process/diy/staging/get/bank",
        bankDetails : "ms-diy-process/diy/staging/add/bank",
        uploadDocument : "ms-diy-process/diy/upload/documents",
        getDocument : "ms-diy-process/diy/find/uploaded/documents",
        deleteDocument: "ms-diy-process/diy/delete/document",
        documentMaster : "ms-diy-process/diy/master/docbyid/",
        documentMasking : "ms-diy-process/diy/OCRimage/encoded",
        segments: "ms-diy-process/diy/master/segments",
        getAddressDetails: "ms-diy-process/diy/staging/get/addressDetails",
        addressDetails : "ms-diy-process/diy/staging/add/addressDetails",
        getOccupationStateAndRelationOptions : "ms-diy-process/diy/master/occstatrel",
        termsCondts: "https://www.tradebulls.in/CustomerResource/TermsAndCondition.pdf",
        stdinstruct:"ms-diy-process/diy/master/stdinstruct",
        getFATCAOptions : "ms-diy-process/diy/master/basicDetails",
        getFATCADetails : "ms-diy-process/diy/staging/get/basicDetails",
        FATCADetails: "ms-diy-process/diy/staging/add/basicDetails",
        getNomineeDetails : "ms-diy-process/diy/staging/get/kycstagingnominee",
        relationOptions : "ms-diy-process/diy/staging/get/relationMaster",
        autoSearch : "ms-backoffice-search/backoffice/autosearch",
        nomineeDetails : "ms-diy-process/diy/staging/add/kycstagingnominee",
        validationRelation: "ms-diy-process/diy/process/validationRelation",
        verifyEmail: "ms-aop-diy-process/diy/sendVerificationEmail",
        verifyOtp: "ms-diy-process/diy/process/verifyOtp",
        getBrokerageDetails: "ms-diy-process/diy/staging/get/brokerage",
        getBrokeragePlans: "ms-diy-process/diy/master/brokgeplan",
        brokerageDetails: "ms-diy-process/diy/staging/add/brokerage",
        getPromotions : "ms-diy-process/diy/staging/get/getPromotionalDetails",
        getDocumentsData : "ms-diy-process/diy/master/getFilteredDocs",
        stageDetails: "ms-diy-process/diy/staging/get/stageDetails",
        getDigiLockerData: "ms-aop-diy-process/diy/digiLockerData/get",
        addDigiLockerData: "ms-aop-diy-process/diy/digiLockerData/add",
        fetchReviewDetails: "ms-diy-process/diy/staging/get/getdiypreview",
        finalSubmit: "ms-diy-process/diy/staging/finalData",
        previewForm:"ms-diy-process/diy/report/pdfPreview",
        physicalDownload : "ms-diy-process/diy/generate/physicalPDF",
        esign: "ms-diy-process/diy/eSign/generate",
        getEsignDoc: "ms-diy-process/diy/eSign/signdoc",
        kycData: "ms-diy-process/diy/report/kycData",
        getObjections : "ms-diy-process/diy/scrutiny/report/kycid/",
        addCourier: "ms-diy-process/diy/staging/add/kyccouriertracking",
        getPANEncodingData :"ms-diy-process/diy/image/encoded/",
        sendPhotoCaptureLink: "ms-diy-process/diy/process/sendPhotoRequest",
        sendVideoCaptureLink: "ms-diy-process/diy/process/sendVideoRequest",
        generateQR: "ms-aop-diy-process/diy/generateQr", 
        getPanRelateData:"ThirdPartyAPI/PANDetails",
        generateToken:"/ms-diy-process/tokenGenerator",
        reVerify:"ms-diy-process/diy/process/reVerifyPan",
        customerHandout:"/api/getCustomerHandout",
        uploadSegment:"ms-diy-process/diy/process/segment/updateDetails",
        getSegment:"ms-diy-process/diy/process/segment/getDetails",
        sendArambhVideoRequest:"ms-diy-process/diy/process/sendArambhVideoRequest",

        verifySignature:"documentVerification/verifySignature",
        verifyPAN:"documentVerification/verifyPAN",
        verifyAadhar:"documentVerification/verifyAadhaar",
        aarambhLogin:"authorised/login",
        aarambhLogout:"authorised/logout",
        getVideoUnqCode:'ms-diy-process/diy/process/getVideoUnqCode',
        getUniqueCode:'ms-diy-process/diy/process/getUniqueCode',
        uploadIPVAnalysis:"documentVerification/uploadIPVAnalysis",
        uploadImageAnalysis:"documentVerification/imageAnalysis",
        bankVerificationQR:"ms-bank-payment/bank/payment/bankVerificationQR"
}

export default config;